// src/components/CardEditor/CardSide.tsx
// ✅ ATUALIZADO: Recebe subdeckName e passa para RichTextEditor

import React from 'react';
import { RichTextEditor } from '../../components/CardEditor/RichTextEditor';
import './CardSide.css';

interface CardSideProps {
    label: string;
    content: string;
    setContent: (content: string) => void;
    placeholder?: string;
    editorType: 'front' | 'back' | 'support';
    editorId: string;
    subdeckName?: string;
    isRestricted?: boolean;
}

export const CardSide: React.FC<CardSideProps> = ({
    label,
    content,
    setContent,
    placeholder,
    editorType,
    editorId,
    subdeckName = 'geral',
    isRestricted
}) => {
    return (
        <div className="card-side-column">
            <div className="card-side-header">
                <label className="card-side-label">{label}</label>
            </div>
            <RichTextEditor
                key={editorId}
                editorId={editorId}
                editorType={editorType}
                content={content}
                setContent={setContent}
                placeholder={placeholder || `Digite a ${label.toLowerCase()}...`}
                subdeckName={subdeckName}
                isRestricted={isRestricted}
            />
        </div>
    );
};